








import Vue from 'vue';

export default Vue.extend({
  name: 'Spinner',
  props: {
    variant: { type: String, default: undefined },
    size: { type: String, default: 'small' },
    inline: { type: Boolean, default: false },
  },
  computed: {
    className(): Record<string, boolean> {
      return {
        'slds-spinner': true,
        [`slds-spinner_${this.variant}`]: this.variant !== undefined,
        [`slds-spinner_${this.size}`]: true,
        'slds-spinner_inline': this.inline,
      };
    },
  },
});
